import { SET_BUSQUEDA_GLOBAL_RESULTADOS } from '../types';

export const setBusquedaGlobalResultados = (resultados) => ({
    type: SET_BUSQUEDA_GLOBAL_RESULTADOS,
    payload: resultados
});

export const resetBusquedaGlobalResultados = () => ({
    type: SET_BUSQUEDA_GLOBAL_RESULTADOS,
    payload: null
});
